<template>
  <v-card flat>
    <contract-upgrade-calculator v-if="false" :preisKombiAbo="690" vertragsEndDatum="2024-12-06"></contract-upgrade-calculator>
    <employee-list v-if="false"></employee-list>
    <album-manager v-if="false"></album-manager>
    <push-settings></push-settings>
  </v-card>
</template>

<script>
import contractUpgradeCalculator from "@/views/dashboard/contract/utils/contractUpgradeCalculator"
import employeeList from "@/views/dashboard/employee/employeeList"
import albumManager from "@/views/google/display/albumManager"
import pushSettings from "@/components/notification/pushSettings.vue"

export default {
  components: {
    contractUpgradeCalculator,
    employeeList,
    albumManager,
    pushSettings,
  },
  data() {
    return {}
  },
  async created() {},
  methods: {},
}
</script>
